import { render, staticRenderFns } from "./ProjectContentTreasureHunt.vue?vue&type=template&id=06e0f087&scoped=true&"
import script from "./ProjectContentTreasureHunt.vue?vue&type=script&lang=js&"
export * from "./ProjectContentTreasureHunt.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContentTreasureHunt.vue?vue&type=style&index=0&id=06e0f087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e0f087",
  null
  
)

export default component.exports